import { createContext, useContext } from "react";
import type { SsrPayload } from "./types";

let payload: SsrPayload | undefined;

export function setSsrData(next: SsrPayload | undefined): void {
  payload = next;
}

export function getSsrData(): SsrPayload | undefined {
  return payload;
}

export const SsrDataContext = createContext<SsrPayload | undefined>(undefined);

export function useSsrData(): SsrPayload | undefined {
  const fromContext = useContext(SsrDataContext);
  return fromContext ?? payload;
}

declare global {
  interface Window {
    __SSR_DATA__?: SsrPayload;
  }
}

export function readBrowserSsrData(): SsrPayload | undefined {
  if (typeof window === "undefined") return payload;
  return window.__SSR_DATA__ ?? payload;
}
